<template>
  <div>
    Language: {{ language }}
  </div>
</template>

<script>
  export default {
    name: 'setData',

    data () {
      return {
        language: '英語'
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/setData.vue